import { ErrorBoundary, PlatformConfigProvider } from "@aurem/components";
import * as Sentry from "@sentry/react";
import { AnalyticsProvider } from "providers/AnalyticsProvider";
import { ApolloClientProvider } from "providers/ApolloClientProvider";
import { AuthProvider } from "providers/AuthProvider";
import { FeaturesProvider } from "providers/FeaturesProvider";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { handlePreloadError } from "./root/handlePreloadError";

handlePreloadError();

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <>
    {/* eslint-disable-next-line no-console */}
    <ErrorBoundary logError={console.error}>
      <AuthProvider>
        <ApolloClientProvider>
          <FeaturesProvider>
            <PlatformConfigProvider>
              <BrowserRouter>
                <AnalyticsProvider>
                  <App />
                </AnalyticsProvider>
              </BrowserRouter>
            </PlatformConfigProvider>
          </FeaturesProvider>
        </ApolloClientProvider>
      </AuthProvider>
    </ErrorBoundary>
  </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
